module.exports = __webpack_public_path__ + "fonts/MrEavesModOT-Bold.d13f896e.woff2";